adminApp.directive("socketRegister", function(){
	return {
		templateUrl: '/public/directives/socketRegister.html',
	}
});
